import { LoginForm } from "@modules";

export const PageLogin = () => {
  return <LoginForm />;
};
